if (!customElements.get('crossx-material-gallery')) {
  customElements.define('crossx-material-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.images = [...this.querySelectorAll('[data-gallery-image]')];
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.images.length || typeof this.dialog.showModal !== 'function') return;
      this.stage = this.querySelector('[data-gallery-stage]');
      this.closeButton = this.querySelector('[data-gallery-close]');
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-gallery-image]');
        if (link && this.contains(link) && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
          event.preventDefault();
          this.opener = link;
          this.showImage(this.images.indexOf(link));
          this.dialog.showModal();
          this.closeButton.focus();
        }
      }, options);
      this.closeButton.addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('[data-gallery-previous]').addEventListener('click', () => this.showImage(this.index - 1), options);
      this.querySelector('[data-gallery-next]').addEventListener('click', () => this.showImage(this.index + 1), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.stage.replaceChildren();
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.showImage(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
        if (event.key === 'Tab') {
          const controls = [...this.dialog.querySelectorAll('button')];
          const first = controls[0];
          const last = controls.at(-1);
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }, options);
    }

    showImage(index) {
      this.index = (index + this.images.length) % this.images.length;
      const source = this.images[this.index];
      const image = new Image();
      image.src = source.href;
      image.alt = source.dataset.alt;
      image.width = Number(source.dataset.width);
      image.height = Number(source.dataset.height);
      this.stage.replaceChildren(image);
      this.querySelector('[data-gallery-title]').textContent = source.dataset.title;
      this.querySelector('[data-gallery-caption]').textContent = source.dataset.caption;
      this.querySelector('[data-gallery-position]').textContent = this.dialog.dataset.positionLabel.replace('[current]', String(this.index + 1)).replace('[total]', String(this.images.length));
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
